import React from "react";
import { Styles } from "./styles";
import SearchResultIcon from "../../../../../Assets/images/dashboard/icons/searchResult.svg";
import MainPageIcon from "../../../../../Assets/images/dashboard/icons/mainPage.svg";
import BlukWhatsappIcon from "../../../../../Assets/images/dashboard/icons/BlukWhatsapp.svg";
import BlukTelegramIcon from "../../../../../Assets/images/dashboard/icons/BlukTelegram.svg";
import PinUpIcon from "../../../../../Assets/images/dashboard/icons/PinUp.svg";
import CircularProgressChart from "./CircularProgressChart";

const ActiveTicketServiceCard = ({ data }) => {
  // Calculate days left
  const calculateDaysLeft = (endDate) => {
    if (!endDate) return 0;

    const end = new Date(endDate);
    const now = new Date();

    // Reset time part to compare only dates
    end.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);

    // Calculate difference in days
    const timeDiff = end.getTime() - now.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    // Return 0 if the date has already passed
    return daysDiff > 0 ? daysDiff : 0;
  };

  const daysLeft = calculateDaysLeft(data?.end_date);

  return (
      <Styles>
        <div className="main-container">
          <div className="title-container">
            <div className="main-data">
              <img
                  src={
                    data?.service === "Main Page"
                        ? MainPageIcon
                        : data?.service === "Search Results"
                        ? SearchResultIcon
                        : data?.service === "Bulk Whatsapp"
                            ? BlukWhatsappIcon
                            : data?.service === "Bulk Telegram"
                                ? BlukTelegramIcon
                                : data?.service === "Pin Up"
                                    ? PinUpIcon
                                    : SearchResultIcon
                  }
                  alt="icon"
                  className="icon"
              />
              <div className="title">{data?.service}</div>
              <div className="description">({data?.type})</div>
            </div>
            <div className="secondary-data">
              <div className="price">{data?.price}$</div>
            </div>
          </div>
          <div className="data-container">
            <div className="main-data">
              <div className="item">
                <div className="name">Panel</div>
                <div className="description url">
                  <a href={data?.panel_url} target="_blank" rel="noopener noreferrer">
                    {data?.panel_url}
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="long-name">All Ticket (message)</div>
                <div className="description">{data?.all_tickets}</div>
              </div>
              <div className="item">
                <div className="long-name">Sent Tickets</div>
                <div className="description">{data?.sent_tickets}</div>
              </div>
            </div>
            <div className="statistic-data">
              <div className="chart">
                <CircularProgressChart percentage={data?.percentage || 0} />
              </div>
              <div className="days-left">
                <div className="number">{data?.remaining_tickets}</div>
                <div className="name">Remaining Ticket</div>
              </div>
            </div>
          </div>
        </div>
      </Styles>
  );
};

export default ActiveTicketServiceCard;